import React from 'react';
import { Box, Card, Group, Image, Stack, Text, Title } from '@mantine/core';
import Button from 'components/button/button';

const CommunityPageCard = ({
  children,
  title,
  description,
  primary_button_label,
  primary_button_url,
  secondary_button_label,
  secondary_button_url,
  image_url,
}) => {
  const showPrimaryButton = primary_button_label && primary_button_url;
  const showSecondaryButton =
    showPrimaryButton && secondary_button_label && secondary_button_url;

  return (
    <Card withBorder radius='md' p={0} h='100%'>
      <Image src={image_url} alt={title} fit='cover' h={192} />
      <Stack flex={1} gap='xs' p='lg' mih={238}>
        <Title order={2} size='lg'>{title}</Title>
        <Text c='dimmed' size='sm'>{description}</Text>
        {
          children ? (
            <Box mt='auto'>{children}</Box>
          ) : showPrimaryButton && (
            <Group gap='lg' mt='auto'>
              <Button to={primary_button_url}>
                {primary_button_label}
              </Button>
              {
                showSecondaryButton &&
                  <Button
                    to={secondary_button_url}
                    background='transparent'
                    backgroundOnActive='transparent'
                    backgroundOnHover='transparent'
                    color='#868E96'
                    fontWeight='normal'
                    height='auto'
                    padding={0}
                    scaleOnActive={1}
                    style={{textDecoration: 'underline'}}
                  >
                    {secondary_button_label}
                  </Button>
              }
            </Group>
          )
        }
      </Stack>
    </Card>
  );
};

export default CommunityPageCard;
